import React from 'react'
import clsx from 'clsx'

const RadioButton = ({
  value,
  checked,
  onChange,
  disabled = false,
  className = '',
  radioClassName = '',
  label,
  name,
  size = 'md',
  ...props
}) => {

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }

  const radioSizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3',
  }
  return (
    <div className={clsx('flex items-center', className)}>
      <div
        className={clsx(
          'relative',
          sizeClasses[size],
          'rounded-full',
          'border-2',
          'flex',
          'items-center',
          'justify-center',
          'transition-all',
          'duration-200',
          'cursor-pointer',
          checked && 'border-v3-purple-primary',
          !checked && 'border-v3-black-inactive',
          disabled && 'opacity-50 cursor-not-allowed',
          radioClassName
        )}
      >
        <input
          type="radio"
          value={value}
          checked={checked}
          onChange={(e) => {
            if (!disabled && onChange) {
              onChange(e.target.value)
            }
          }}
          disabled={disabled}
          name={name}
          className="absolute opacity-0 w-full h-full cursor-pointer"
          {...props}
        />
        {checked && (
          <span
            className={clsx(
              'rounded-full pointer-events-none',
              radioSizeClasses[size]
            )}
            style={{
              backgroundColor: 'var(--v3-purple-primary)',
            }}
          />
        )}
      </div>
      {label && (
        <label 
          className={clsx(
            'ml-v3-xs',
            'cursor-pointer',
            'text-v3-black-max',
            'text-v3-h9',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
          onClick={(e) => {
            if (!disabled && onChange) {
              e.preventDefault()
              onChange(value)
            }
          }}
        >
          {label}
        </label>
      )}
    </div>
  )
}

export default RadioButton

